// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"cxkNY":[function(require,module,exports,__globalThis) {
// api-interactions.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchObjects", ()=>fetchObjects);
parcelHelpers.export(exports, "fetchMyObjects", ()=>fetchMyObjects);
parcelHelpers.export(exports, "fetchObject", ()=>fetchObject);
parcelHelpers.export(exports, "createObject", ()=>createObject);
parcelHelpers.export(exports, "updateObject", ()=>updateObject);
parcelHelpers.export(exports, "deleteObject", ()=>deleteObject);
const API_BASE_URL = 'https://learningface.ai/objects';
const API_MY_OBJECTS_URL = `https://learningface.ai/userObjects`; // Endpoint to get just the users objects
async function fetchObjects() {
    try {
        const response = await fetch(API_BASE_URL);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}
async function fetchMyObjects() {
    console.log(`Fetching user's objects FROM: ${API_MY_OBJECTS_URL}`);
    try {
        const response = await fetch(API_MY_OBJECTS_URL);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }
        // Parse the response JSON once and reuse it
        const data = await response.json();
        console.log('Response data:', data);
        return data;
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}
async function fetchObject(key) {
    try {
        console.log(`Fetching object with key: ${key}`);
        const response = await fetch(`${API_BASE_URL}/${key}.json`);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            const errorDetails = await response.json();
            throw new Error(errorDetails.error || message);
        }
        return await response.json(); // Assuming API returns the object content as text
    } catch (error) {
        console.error(`Error fetching object "${key}":`, error);
        throw error;
    }
}
async function createObject(objectData) {
    try {
        const response = await fetch(`${API_BASE_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objectData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create object');
        }
        return await response.json(); // Or response.text() depending on your API response
    } catch (error) {
        console.error(`Error creating object "${objectData}":`, error);
        throw error;
    }
}
async function updateObject(key, objectData) {
    try {
        // **IMPORTANT:** You need to implement the PUT endpoint in your server.js
        const response = await fetch(`${API_BASE_URL}/${key}.json`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objectData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error updating object "${key}":`, error);
        throw error;
    }
}
async function deleteObject(key) {
    try {
        const response = await fetch(`${API_BASE_URL}/${key}.json`, {
            method: 'DELETE'
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to delete object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error deleting object "${key}":`, error);
        throw error;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["cxkNY"], "cxkNY", "parcelRequireed96", {})

//# sourceMappingURL=learningface.ai.8e4eb2d0.js.map
